import { render } from "./ProjectUpdateContent.vue?vue&type=template&id=3a94db72"
import script from "./ProjectUpdateContent.vue?vue&type=script&lang=js"
export * from "./ProjectUpdateContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__